import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../../assets/svg/svg12.svg";
import svg15 from "../../../../../../../assets/svg/svg15.svg";
import svg29 from "../../../../../../../assets/svg/svg29.svg";
import svg49 from "../../../../../../../assets/svg/svg49.svg";
import CardLoading from "../../../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import {
  fetchData,
  fetchMemberTypes,
} from "../../../../../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../../../../../features/obj/objSlice";
import { formatText } from "../../../../../../../utils";
import moment from "moment";
import useModalToggle from "../../../../../../../custom_hooks/useModalToggle";
import MembersAdd from "./modal/MembersAdd";
import ConfirmModal from "../../../../../../../components/ConfirmModal";
import { save } from "../../../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import MembersView from "./MembersView";

function ProjectTeamTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/mainProject/member/get";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    })
  );
  const { refetchKey } = useSelector((state) => state.global);

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/mainProject/member/delete",
        pmId: prodd?.pmId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        pmName: e.target.value == "" ? null : e.target.value,
        pmProjectId: activeObjOngoingProject?.projectId,
      })
    );
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };
  const handleView = async () => {
    await showDrawer();
  };
  const handleViewName = async (item) => {
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" />{" "}
            <span className="whitespace-nowrap">Edit</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" />{" "}
            <span className="whitespace-nowrap">View</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg49} alt="svg49" className="w-4 h-4" />
            <span className="whitespace-nowrap">Disable</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Member",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.pmName}
          </div>
        );
      },
      sorter: (a, b) => a.pmName.localeCompare(b.pmName),
    },

    {
      title: "Email",
      dataIndex: "pmEmail",
      sorter: (a, b) => a.pmEmail.localeCompare(b.pmEmail),
    },
    {
      title: "Phone",
      dataIndex: "pmPhone",
      sorter: (a, b) => a.pmPhone.localeCompare(b.pmPhone),
    },
    {
      title: "National ID",
      dataIndex: "pmIdNumber",
      sorter: (a, b) => a.pmIdNumber.localeCompare(b.pmIdNumber),
    },
    {
      title: "Role",
      dataIndex: "pmRole",
      sorter: (a, b) => a.pmRole.localeCompare(b.pmRole),
    },
    {
      title: "Created",
      dataIndex: "createdDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.createdDate).valueOf() - moment(b.createdDate).valueOf(),
    },
    ...(!["COMPLETED", "STALLED"]?.includes(activeObjOngoingProject?.projectStatus)
      ? [
          {
            title: "Actions",
            render: (item) => (
              <>
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                >
                  <button onClick={() => setProdd(item)}>
                    <img src={svg27} alt="svg27" />
                  </button>
                </Dropdown>
              </>
            ),
          },
        ]
      : []),
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pmProjectId: activeObjOngoingProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    dispatch(fetchMemberTypes());
  }, []);
  useEffect(() => {
    if (refetchKey == 1) {
      fetchTableData();
      dispatch(fetchMemberTypes());
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="flex flex-col w-full  flex-1   mt-[2.5rem]">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="form-add-h">Project Team</div>

        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full  ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          <div className="w-[150px]">
            {activeObjOngoingProject?.projectStatus === "COMPLETED" || activeObjOngoingProject?.projectStatus === "STALLED" ? null : (
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />
                <span className="ml-1">Add Team</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-full w-full overflow-x-auto">
        <Table
          rowSelection={false}
          className="mt-[1.75rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.pmId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <MembersView onClose={onClose} open={openDrawer} prodd={prodd} />

      <MembersAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />
    </div>
  );
}

export default ProjectTeamTable;
